<template>
  <div style="padding-bottom: 15px">
    <TravelRouteCustomerAdd ref="routeCustomer" @customer="newCustomer" />
    <el-radio-group
      v-model="collapse"
      style="margin-bottom: 20px"
      size="mini"
      @change="$emit('expand', collapse)"
    >
      <el-radio-button :label="false"
        ><i title="Esconder mapa" class="el-icon-view"></i
      ></el-radio-button>
      <el-radio-button :label="true"
        ><i title="Ver mapa" class="el-icon-map-location"></i
      ></el-radio-button>
    </el-radio-group>
    <div>
      <el-steps direction="vertical" :active="0" :collapse="collapse">
        <el-step
          status="process"
          icon="el-icon-circle-plus-outline"
          style="cursor: pointer"
          @click.native="add"
        >
          <template slot="title">
            <span style="color: green">Adicionar a rota</span>
          </template>
          <template slot="description">
            <span style="color: green" v-if="!collapse"
              >Adicione um novo endereço a rota do motorista</span
            >
          </template>
        </el-step>
        <el-step
          title="A"
          description="Localização do motorista"
          icon="fa fa-map-marker"
        ></el-step>
        <el-step
          v-for="(item, index) of customer"
          :key="index"
          :icon="
            item.customerData.formData.type == '1'
              ? 'el-icon-office-building'
              : item.customerData.formData.type == '2'
              ? 'el-icon-school'
              : 'el-icon-collection'
          "
          :status="
            item.customerData.formData.type == '3' ? 'success' : 'process'
          "
        >
          <template slot="title">
            <span>{{ item.marker }}</span>
          </template>
          <div
            slot="description"
            style="
              display: flex;
              justify-content: space-between;
              position: relative;
            "
          >
            <span style="z-index: 1">
              <span style="font-weight: 600">
                {{ item.title }}
              </span>
              <span v-if="!collapse" style="font-size: 10px">
                <br />
                {{ item.customerData.address.address.formatted }}
              </span>
              &nbsp; <el-tag v-if="!collapse"> {{ item.time }} </el-tag>
            </span>

            <div style="z-index: 999" class="right" v-if="!collapse">
              <el-button
                size="mini"
                v-if="index > 0"
                type="info"
                @click="up(index)"
                icon="el-icon-upload2"
              ></el-button>
              <el-button
                size="mini"
                v-if="index < customer.length - 1"
                @click="down(index)"
                type="info"
                icon="el-icon-download"
              ></el-button>
              <el-button
                size="mini"
                type="warning"
                icon="el-icon-delete"
                @click="remove(index)"
              ></el-button>
            </div>
          </div>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>

<script>
import TravelRouteCustomerAdd from "./TravelRouteCustomerAdd.vue";

export default {
  name: "TravelNavigator",
  data() {
    return {
      collapse: false,
      customer: [],
      letter: "A",
    };
  },

  props: {
    currentCustomers: Array,
  },

  methods: {
    nextChar(c) {
      return String.fromCharCode(c.charCodeAt(0) + 1);
    },

    newCustomer(mapData) {
      this.letter = this.nextChar(this.letter);
      this.customer.push({
        marker: this.letter,
        title: mapData.address.name,
        time: mapData.formData.time,
        customerData: mapData,
      });
      this.$emit("address", mapData);
    },

    add() {
      const position =
        this.customer.length > 0
          ? this.customer[this.customer.length - 1]
          : null;
      this.$refs.routeCustomer.open(position);
    },

    up(index) {
      const timeUp = this.customer[index].time;
      const timeDown = this.customer[index - 1].time;
      this.customer[index].time = timeDown;
      this.customer[index - 1].time = timeUp;
      const data = this.customer[index];
      this.customer.splice(index - 1, 0, data);
      this.customer.splice(index + 1, 1);
      this.$emit("generate", this.customer);
      this.recalculateMarker();
    },

    down(index) {
      const timeUp = this.customer[index].time;
      const timeDown = this.customer[index + 1].time;
      this.customer[index].time = timeDown;
      this.customer[index + 1].time = timeUp;
      const data = this.customer[index];
      const changed = this.customer[index + 1];
      this.customer.splice(index + 2, 0, data);
      this.customer.splice(index, 1);
      this.$emit("generate", this.customer);
      this.recalculateMarker();
    },

    remove(index) {
      this.customer.splice(index, 1);
      this.$emit("generate", this.customer);
      this.recalculateMarker();
    },

    recalculateMarker() {
      let currentLetter = "A";
      for (const item of this.customer) {
        currentLetter = this.nextChar(currentLetter);
        item.marker = currentLetter;
      }
    },
  },

  mounted() {
    if (this.currentCustomers) {
      for (const item of this.currentCustomers) {
        this.letter = this.nextChar(this.letter);
        this.customer.push({
          marker: this.letter,
          title: item.address.name,
          time: item.formData.time,
          customerData: item,
        });

        this.$emit("address", item);
      }
    }
  },

  components: { TravelRouteCustomerAdd },
};
</script>
